export const OEM_REQUEST = "OEM_REQUEST"
export const OEM_GET_SUCCESS = "OEM_GET_SUCCESS"
export const OEM_FAILED = "OEM_FAILED"